import { render, staticRenderFns } from "./ywzx_add.vue?vue&type=template&id=d7f61ba2&"
import script from "./ywzx_add.vue?vue&type=script&lang=js&"
export * from "./ywzx_add.vue?vue&type=script&lang=js&"
import style0 from "./ywzx_add.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports